import { render, staticRenderFns } from "./SwiperCard.vue?vue&type=template&id=f48e6700&scoped=true&"
import script from "./SwiperCard.vue?vue&type=script&lang=js&"
export * from "./SwiperCard.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCard.vue?vue&type=style&index=0&id=f48e6700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e6700",
  null
  
)

export default component.exports